(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-swatches"] && !Shopify.designMode) return;
  try {
    // Hovering a swatch swaps the card's first gallery image to that variant's
  // featured image (data-image/-srcset/-alt from snippets/bst-swatches.liquid),
  // and restores it on pointerout. Delegated on document so cards inserted
  // later (filtering, pagination, quick-add) work without re-binding.
  // Same approach as initSwatchImagePreview in assets/bst-shop-all.js.
  (() => {
    if (window.__bstCardSwatchPreview) return;
    window.__bstCardSwatchPreview = true;

    const preloaded = new Set();

    const getCardImage = (swatch) =>
      swatch.closest('product-card')?.querySelector('.card-gallery .product-media__image');

    document.addEventListener('pointerover', (event) => {
      if (!(event.target instanceof Element)) return;

      const card = event.target.closest('product-card');
      if (card && !card.__bstSwatchesPreloaded) {
        card.__bstSwatchesPreloaded = true;
        card.querySelectorAll('.bst-product-card-swatches .bst-swatches__item[data-image]').forEach((swatch) => {
          const url = swatch.dataset.image;
          if (preloaded.has(url)) return;
          preloaded.add(url);
          const image = new Image();
          image.srcset = swatch.dataset.imageSrcset || '';
          image.src = url;
        });
      }

      const swatch = event.target.closest('.bst-product-card-swatches .bst-swatches__item[data-image]');
      const img = swatch && getCardImage(swatch);
      if (!img) return;

      if (!img.dataset.bstOriginalSrc) {
        img.dataset.bstOriginalSrc = img.getAttribute('src') || '';
        img.dataset.bstOriginalSrcset = img.getAttribute('srcset') || '';
        img.dataset.bstOriginalAlt = img.getAttribute('alt') || '';
      }

      img.srcset = swatch.dataset.imageSrcset || '';
      img.src = swatch.dataset.image;
      img.alt = swatch.dataset.imageAlt || img.dataset.bstOriginalAlt;
    });

    document.addEventListener('pointerout', (event) => {
      if (!(event.target instanceof Element)) return;

      const swatch = event.target.closest('.bst-product-card-swatches .bst-swatches__item[data-image]');
      if (!swatch || swatch.contains(event.relatedTarget)) return;

      const img = getCardImage(swatch);
      if (!img || img.dataset.bstOriginalSrc === undefined) return;

      img.srcset = img.dataset.bstOriginalSrcset;
      img.src = img.dataset.bstOriginalSrc;
      img.alt = img.dataset.bstOriginalAlt;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
